// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6ad8fe85","107":"669665d1","495":"e2e59367","710":"818b2f00","897":"3d5bda49","944":"e6a04d62","951":"97ab6d64","955":"ad598d97"}[chunkId] + ".chunk.js";
};